module.exports = __webpack_public_path__ + "img/DAVID_CANNON_02-rs.49c3848d.jpg";